import { Dialog } from '@headlessui/react';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTranslation from '../../../../../hooks/useTranslations';
import { closeFavoritesFormModal, createFavoriteList, openFavoritesFormModal, selectFavoritesFormModalIsOpen } from '../../../../../redux/modules/favoritesSlice';
import Inputfield from '../../../../misc/Inputfield';
import ModalWrapper from '../../../layouts/partials/ModalWrapper';

const FavoritesModal = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const [title, setTitle] = useState('');

	const isFavoritesModalOpen = useSelector((state) => (selectFavoritesFormModalIsOpen(state)));

	const setIsModalOpen = useCallback((shouldOpen) => {
		if (shouldOpen) {
			dispatch(openFavoritesFormModal());
		} else {
			dispatch(closeFavoritesFormModal());
		}
	}, [dispatch]);

	const save = () => {
		if (title.length) {
			dispatch(createFavoriteList({ title }));
			setIsModalOpen(false);
		}
	};

	return (
		<ModalWrapper isModalOpen={isFavoritesModalOpen} setIsModalOpen={setIsModalOpen}>
			<Dialog.Title
				as="h3"
				className="text-[1.25rem] font-semibold text-oly-gray-darkest text-center mb-4"
			>
				{t('eval_app_create_report_title')}
			</Dialog.Title>
			<Dialog.Description
				as="p"
				className="text-[1.0625rem] text-oly-gray-darkest text-center mb-8 leading-6"
			>
				{t('webapp_favs_add_temp')}
			</Dialog.Description>
			<div className="w-full max-w-sm pb-8 mx-auto">
				<Inputfield fieldName="newFavList" label={t('favorite_list_add_alert_input_placeholder')} placeholder={t('favorite_list_add_alert_input_placeholder')} handleChange={setTitle} />
			</div>
			<div className="flex -mx-6 border-t divide-x border-oly-gray-lightest divide-oly-gray-lightest">
				<button
					type="button"
					className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-normal text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
					onClick={() => setIsModalOpen(false)}
				>
					{t('bookmarks_remove_cancel')}
				</button>
				<button
					type="button"
					className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-semibold text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none disabled:text-oly-gray-normal disabled:!bg-white disabled:cursor-not-allowed disabled:opacity-75"
					onClick={() => save()}
					disabled={!title.length}
				>
					{t('favorite_list_add_alert_button')}
				</button>
			</div>
		</ModalWrapper>
	);
};

export default FavoritesModal;
